export default {
    sms_system_main_title: "SMS Systems",
    sms_system_main_id: "Id",
    sms_system_main_name: "Name",
    sms_system_main_display_name: "Display Name",
    sms_system_main_priority: "Priority",
    sms_system_main_status: "Status",
    sms_system_main_add: "Add SMS System",
    sms_system_main_delete: "Delete SMS System",
    sms_system_main_edit: "Create SMS System",
}